import { render, staticRenderFns } from "./catalogtovars.vue?vue&type=template&id=05872f89&"
import script from "./catalogtovars.vue?vue&type=script&lang=js&"
export * from "./catalogtovars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports